import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";
import { DEFAULT_HOOKS_MODAL_ID, getWsConfigFromState } from "app/pages/workspace/config/stateToWsConfigMap";
import { EHooksVersions, openHook } from "app/services/SwHook";
import { SwRedux } from "app/services/SwRedux";

import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import { openContactUsModal as openContactUsModalAction } from "../actions/contactUsModalActions";

export function openStateUnlockModal(state, params?) {
    const { unlockHook } = getWsConfigFromState(state);
    const { key, overrideTrackingKey, location, version } = unlockHook;
    if (key === DEFAULT_HOOKS_MODAL_ID) {
        openDefaultHooksModal(overrideTrackingKey, location);
        return;
    } else {
        switch (version) {
            case EHooksVersions.V6:
                openHooksModalV6(key, location, overrideTrackingKey);
                break;
            default:
                openHooksModalV5(key, location, overrideTrackingKey);
        }
    }
}

export type HookType = "website" | "keywords" | "creatives" | "pages" | "";

export function openHooksModalV4(key: string, location?: string, overrideTrackingKey?: string) {
    const openHookLocation = location ? location : LocationService.getCurrentLocationTracking();
    openHook(key, overrideTrackingKey, openHookLocation, "v4").catch((reason) =>
        Sentry.error("error on open hook modal v4: ", reason, { tags: { team: TEAMS.LYNX } }),
    );
}

export function openHooksModalV5(key: string, location?: string, overrideTrackingKey?: string, defaultStep?: string) {
    const openHookLocation = location ? location : LocationService.getCurrentLocationTracking();
    openHook(key, overrideTrackingKey, openHookLocation, "v5", defaultStep).catch((reason) =>
        Sentry.error("error on open hook modal v5: ", reason, { tags: { team: TEAMS.LYNX } }),
    );
}

export function openHooksModalV6(key: string, location?: string, overrideTrackingKey?: string) {
    const openHookLocation = location ? location : LocationService.getCurrentLocationTracking();
    openHook(key, overrideTrackingKey, openHookLocation, "v6").catch((reason) =>
        Sentry.error("error on open hook modal v6: ", reason, { tags: { team: TEAMS.LYNX } }),
    );
}

export function openDefaultHooksModal(overrideTrackingKey?, location?) {
    openHook(DEFAULT_HOOKS_MODAL_ID, overrideTrackingKey, location, "v5").catch((reason) =>
        Sentry.error("error on open Default hook modal v5: ", reason, { tags: { team: TEAMS.LYNX } }),
    );
}

export function openContactUsModal(label) {
    SwRedux.getInstance().dispatch(openContactUsModalAction(label));
}
